module.exports = __webpack_public_path__ + "media/favicon/favicon-32x32-e1d19760.png";